var _ = require("lodash");

module.exports = {
  hasPrivilegeFunc(path, privileges, test, req) {
        var tempPath = path.split('.');
        if(privileges) {
            if(_.get(privileges, path, false)) {
                var obj = _.get(privileges, path, false);
                if(test) {
                    if(typeof test !== 'function') {
                        throw new TypeError('Test is not a valid fucntion');
                    } else {
                        var has = test(req, path, privileges);
                        return Promise.resolve(has).then(function(has) {
                            return has;
                        });
                    }
                } else if(typeof obj === "boolean") {
                    if(obj) {
                        return true;
                    } else {
                        return false;
                    }
                } else if(typeof obj === "object") {
                    var filterPath = path.split(".").concat("filter")
.join(".");
                    var filterObj = _.get(privileges, filterPath, false);
                    if(filterObj && req) {
                        req.filterParam = filterObj;
                        //let query={};
                        //if(filterObj.type === "Except") {
                            //query["$nin"]= filterObj.data;
                        //} else {
                            //query["$in"] =  filterObj.data;
                        //}
                        //if(req) {
                            //req.filterParam = query;
                        //}
                    }
                    if(obj.active) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else if(tempPath[tempPath.length-1]=='active') {
                tempPath.pop();
                path = tempPath.join('.');
                if(_.get(privileges, path, false)) {
                    var obj = _.get(privileges, path, false);
                    if(typeof obj === 'boolean') {
                        if(obj) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
};
